"use strict";

import * as React from "react";
import SelectBox from "../../../controls/SelectBox";

const ProductsDropDown = (props) => {
    var { onChange, selectedProducts, availibleProducts } = props;
    var key = 0;
    return (
        <div id="productsFilter">
            <SelectBox
                label="Products"
                onChange={value => onChange(value)}
                value={selectedProducts}
                multiple={true}>
                {availibleProducts.map(productName => (<option key={key++} value={productName}>{productName}</option>))}
            </SelectBox>
        </div>);
};

export default ProductsDropDown;


